import { Box, Button, Drawer, Stack, Typography } from '@mui/material'
import React, { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../PharmaFilter';
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions';

class SalesMonthly extends Component {

  constructor(props) {
    super(props)
    this.state = {
      salesMonthlyData: [],
      page: 0,
      pageSize: 10,
      rowCount: 0,
      filterDatas: {
        'month': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "dateIndex": 1,
        "days":null
      },
      pageName: 'salesMonthly',
      filterOpen: false,
      totalAmount: 0,
      billAmount: 0,
      returnAmount: 0,
      isLoader: false,
    }
  }

  componentDidMount() {
    this.getSalesMonthlyReportData()
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
      page:0,
    }, () => { this.getSalesMonthlyReportData() })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  clearFilter = (data) => {
    this.setState({
      FilterDatas: data
    })
  }

  formatMonthAndYear = (value) => {
    let month = value.split("-")[1]
    let year = value.split('-')[0]

    return month + "-" + year
  }

  gridToolBar = () => {
    var { t } = this.props
    let TextArray = [
      { label: "Month", value: this.formatMonthAndYear(this.state.filterDatas.month) },
    ]
    return (
      <Box>
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
      </Box>

    )
  }

  getSalesMonthlyReportData = () => {
    try {
      this.LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.PHARMA_SALES_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.LoaderFunction(false);
            this.setState({
              salesMonthlyData: response.data.data?.bill_details,
              totalAmount: response.data.data?.total_amount,
              billAmount: response.data.data?.total_bill_amount,
              returnAmount: response.data.data?.total_return_amount,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false);
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false);
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getSalesMonthlyExcel = () => {
    try {
      this.setState({disableBtn: true})
      RestAPIService.excelGet(Serviceurls.PHARMA_SALES_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&export=excel`).
        then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"].split("filename=")[1]
            // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({disableBtn: false})
          }
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMessage(error.response?.data?.message);
          } else {
            this.errorMessage(error.message);
          }
          this.setState({disableBtn: false})
        })
    } catch (error) {
      this.errorMessage(error.message);
      this.setState({disableBtn: false})
    }
  }
 
  SalesMonthlyPrint = () => {
    try {
      this.setState({disableBtn: true})
      RestAPIService.getAll(Serviceurls.PHARMA_SALES_MONTHLY_REPORT_GET + `?month=${this.state.filterDatas?.month?.split("-")[1]}&year=${this.state.filterDatas?.month?.split("-")[0]}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&export=pdf`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({disableBtn: false})
        }).catch((error) => {
          if(error?.response?.data?.message){
            this.errorMessage(error?.response?.data?.message)
          }else{
            this.errorMessage(error.message)
          }
          this.setState({disableBtn: false})
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({disableBtn: false})
    }
  }


  render() {
    const { t } = this.props
    this.state.salesMonthlyData?.forEach((element, index) => element.sno = index + 1);
    const columns = [
      { field: 'invoice_date', headerName: "Invoice Date", flex: 0.1, headerAlign: "center", align: "center" },
      {
        field: 'bill_amount', headerName: `Bill Amount (${CurrencySymbol})`, flex: 0.1, type: 'number',
        renderCell: ({ row }) => {
          return (<Typography>{AmountFormat(row?.bill_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Typography>)
        }
      },
      {
        field: 'return_amount', headerName: `Return Amount (${CurrencySymbol})`, flex: 0.1, type: 'number',
        renderCell: ({ row }) => {
          return (<Typography>{AmountFormat(row?.return_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Typography>)
        }
      },
      {
        field: 'amount', headerName: `Net Amount (${CurrencySymbol})`, flex: 0.1, type: 'number',
        renderCell: ({ row }) => {
          return (<Typography>{AmountFormat(row?.amount || 0)?.replace(`${CurrencySymbol}`, "")}</Typography>)
        }
      },
    ]
    return (
      <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
        <Box component={'div'} className='eMed_Pharma_rts_header'>
          <Box component={'div'} flex={0.8} display={'flex'}>
            {AmountsCard("Total Bill Amount", (this.state.billAmount || 0), false, "white", false, null, 'rpt_saleMnth_bill_amt')}
            {AmountsCard("Total Return Amount", (this.state.returnAmount || 0), false, "white", false, null, 'rpt_saleMnth_rtn_amt')}
            {AmountsCard("Total Net Amount", (this.state.totalAmount || 0), false, "white", false, null, 'rpt_saleMnth_total_amt')}
          </Box>
          <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
            <Button emed_tid="rpt_saleMnth_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
              <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} />
            </Button>
            <Button className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn}>
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} alt='print' height={'2.3vw'}  width={'2.3vw'} onClick={() => this.SalesMonthlyPrint()}/>
            </Button>
            <Button emed_tid="rpt_saleMnth_export" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => this.getSalesMonthlyExcel()}>
              <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} />
            </Button>
          </Box>
        </Box>
        <Box component={'div'} className='eMed_Pharma_rts_tbl_card'>
          <DataGrid
            className='eMed_Pharma_table'
            rows={this.state.salesMonthlyData}
            columns={columns}
            page={this.state.page}
            pageSize={this.state.pageSize}
            getRowId={(row) => row['sno']}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            rowCount={this.state.salesMonthlyData?.length}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            headerHeight={40}
            disableSelectionOnClick
            pagination
            loading={this.state.isLoader}
          />
        </Box>

        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
        >
          <PharmaFilter pageName={this.state.pageName} filterDatas={this.state.filterDatas} closeFilter={this.ClosePopUp.bind(this)} filteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} />
        </Drawer>

        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </Box>
    )
  }
}

export default withTranslation()(SalesMonthly)